export const arrayIntersect = (array1, array2) =>
  array1.filter(value => array2.includes(value));
